import Vue, { PropType } from "vue";
import { trackPickDateLoadPuzzle, trackPickDateBackToCalendar } from "js/tracking/track";
import { ICalendarDayConfig } from "js/crossword/calendarData";
import { Provider } from "js/crossword/types";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";

import styles from "../css/ChangeDayAdPopup.module.css";

declare const sdkHandler: any;

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    dayData: Object as PropType<ICalendarDayConfig>,
  },
  computed: {
    author(): string | null {
      return this.dayData.author;
    },
  },
  methods: {
    watchAd() {
      sdkHandler.trigger("levelFinish", {
        level: 0,
        score: 0,
        state: "win",
        callback: () => { },
      });
      this.$emit("close");
      this.$emit("loadPuzzle", this.dayData.puzzleUrl);
      trackPickDateLoadPuzzle();
    },
    goBackToCalendar() {
      trackPickDateBackToCalendar();
      this.$emit("openCalendar");
    },
  },
  render() {
    return (
      <PopupContainer customClasses={[styles.container]}>
        <div class={styles.youSelected}>
          {this.localization.get("You selected:")}
        </div>

        <div class={styles.content}>
          <div>
            <puzzle-date date={this.dayData.date} class={styles.date}></puzzle-date>
            {this.author
              ? <div class={styles.author}>
                {this.localization.get("by")}
                    &nbsp;{this.author.toUpperCase()}
              </div>
              : null}
          </div>
        </div>

        <div class={styles.proceedText}>{this.localization.get("Do you want to proceed?")}</div>

        <PopupButtons buttons={[{
          label: this.localization.get("Back"),
          onClick: this.goBackToCalendar,
          reversed: true,
        }, {
          label: this.localization.get("Yes"),
          onClick: this.watchAd,
        }]} />
      </PopupContainer>
    );
  },
});
